import { useMemo } from "react";
import useAuth from "../../hook/useAuth";
import { UserRoleType } from "../../types/constants";

type IProps = {
    role: UserRoleType | UserRoleType[];
    children: any;
};

const AuthWrapper: React.FC<IProps> = ({ role, children }) => {
    const {hasRole} = useAuth()

    const authorized = useMemo(() => hasRole(role), [role, hasRole])

    if (typeof children === "function") {
        return children(authorized)
    }
    return authorized ? children : <></>
}

export default AuthWrapper
